import config, { weather_base_url } from "../config"
const baseUrl = weather_base_url + "weather30d/"
export default {
    // 分页查询天气30天数据
    page: {
        url: baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    // 根据ID获取天气30天数据
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    // 保存或更新天气30天数据
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    // 删除天气30天数据
    delete: {
        url: baseUrl + "delete",
        type: "get",
    },
    // 查询天气30天数据列表
    list: {
        url: baseUrl + "list",
        type: "post",
    }
} 